module.exports = __webpack_public_path__ + "static/media/Tank002.18c3e9ac.png";